import { SnackbarProvider } from 'notistack';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { SnackbarUtilsConfigurator } from '@/utils/snackbar-utils';

import { SidebarProvider } from '../src/contexts/SidebarContext';

import 'nprogress/nprogress.css';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { TourProvider } from './contexts/TourContext';
import { AppInsights } from './services/ApplicationInsights';
import store from './store';
import '../styles.css';
// import AppInitializer from './utils/fingerPrintJS';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

AppInsights.initialize();

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ErrorBoundary onError={error => AppInsights.trackException(error)}>
      <SidebarProvider>
        <BrowserRouter>
          {/* <AppInitializer> */}
          <SnackbarProvider
            maxSnack={6}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <SnackbarUtilsConfigurator />
            <PermissionProvider>
              <AuthProvider>
                <TourProvider>
                  <App />
                </TourProvider>
              </AuthProvider>
            </PermissionProvider>
          </SnackbarProvider>
          {/* </AppInitializer> */}
        </BrowserRouter>
      </SidebarProvider>
    </ErrorBoundary>
  </Provider>
);
